document.documentElement.classList.remove('no-js');

class MobileMenu extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-menu-toggle]');
    this.panel = this.querySelector('[data-menu-panel]');
    this.closeButton = this.querySelector('[data-menu-close]');
    if (!this.button || !this.panel) return;
    this.button.addEventListener('click', () => this.open());
    this.closeButton?.addEventListener('click', () => this.close());
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
    this.panel.addEventListener('click', (event) => {
      if (event.target === this.panel) this.close();
    });
  }

  open() {
    this.panel.hidden = false;
    this.button.setAttribute('aria-expanded', 'true');
    document.body.classList.add('menu-open');
    this.closeButton?.focus();
  }

  close() {
    this.panel.hidden = true;
    this.button.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
    this.button.focus();
  }
}

class DisclosureMenu extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        this.querySelectorAll('details[open]').forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
      });
    });
  }
}

class LocalizationForm extends HTMLElement {
  connectedCallback() {
    const select = this.querySelector('select');
    const form = this.querySelector('form');
    select?.addEventListener('change', () => form?.submit());
  }
}

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-variant-select]');
    this.button = this.querySelector('[data-add-to-cart]');
    this.buttonText = this.querySelector('[data-add-to-cart-text]');
    this.price = this.closest('.product-summary')?.querySelector('[data-product-price] .price__current');
    this.comparePrice = this.closest('.product-summary')?.querySelector('[data-product-price] .price__compare');
    this.sku = this.closest('.product-summary')?.querySelector('[data-product-sku]');
    this.select?.addEventListener('change', () => this.updateVariant());
  }

  updateVariant() {
    const option = this.select?.selectedOptions[0];
    if (!option) return;
    const available = option.dataset.available === 'true';
    if (this.price) this.price.textContent = option.dataset.price || '';
    if (this.comparePrice) {
      this.comparePrice.textContent = option.dataset.comparePrice || '';
      this.comparePrice.hidden = !option.dataset.comparePrice || option.dataset.comparePrice === option.dataset.price;
    }
    if (this.sku) this.sku.textContent = option.dataset.sku || '';
    if (this.button) this.button.disabled = !available;
    if (this.buttonText) this.buttonText.textContent = available ? this.button.dataset.availableText : this.button.dataset.soldOutText;
  }
}

if (!customElements.get('mobile-menu')) customElements.define('mobile-menu', MobileMenu);
if (!customElements.get('disclosure-menu')) customElements.define('disclosure-menu', DisclosureMenu);
if (!customElements.get('localization-form')) customElements.define('localization-form', LocalizationForm);
if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);
